module.exports = __webpack_public_path__ + "img/IM.be0b357d.png";